import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

const prodURL = "https://club-lab.ru";
const mediaBaseUrl =
  window.location.hostname === "localhost" ? "http://localhost:3004" : prodURL;

export function getServerMediaUrl(relativePath) {
  if (!relativePath) return null;

  const normalized = String(relativePath).replace(/^\/+/, "");
  return `${mediaBaseUrl}/${normalized}`;
}

export function useSceneScreenshot(nodeId, propsData) {
  const game = useSelector((state) => state.user?.game);
  const [imageKey, setImageKey] = useState(0);

  const sceneData =
    game?.nodes?.find((node) => String(node.id) === String(nodeId))?.data ??
    propsData;
  const screenpath = sceneData?.screenpath;
  const hasScreenshot = Boolean(screenpath);
  const imageSrc = hasScreenshot
    ? `${getServerMediaUrl(screenpath)}?v=${imageKey}`
    : null;

  useEffect(() => {
    if (screenpath) {
      setImageKey((prev) => prev + 1);
    }
  }, [screenpath]);

  const refreshScreenshot = useCallback(() => {
    setImageKey((prev) => prev + 1);
  }, []);

  return {
    sceneData,
    hasScreenshot,
    imageSrc,
    imageKey,
    refreshScreenshot,
  };
}
